import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/shadcn/dialog'
import { Button } from '@/components/ui/shadcn/button'

export default function CancelSubscriptionModal({ open, onClose, onCancel }) {
  return (
    <Dialog
      open={open}
      onOpenChange={v => {
        if (!v) onClose()
      }}
    >
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Cancel Subscription</DialogTitle>
          <DialogDescription>
            Are you sure you want to cancel your subscription? Once your
            subscription ends, you will no longer have access to:
          </DialogDescription>
        </DialogHeader>
        <ul className="list-disc pl-5 text-sm text-muted-foreground space-y-1">
          <li>AI features and token usage</li>
          <li>Integrations</li>
          <li>Transcription minutes</li>
        </ul>
        <p className="text-sm text-muted-foreground">
          Your subscription will remain active until the end of your current
          billing period.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Keep Subscription
          </Button>
          <Button variant="destructive" onClick={onCancel}>
            Cancel Subscription
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
